module.exports = __webpack_public_path__ + "img/20171113191009_42681.2ca0b388.jpg";